import { Link } from "react-router-dom";
import { ShieldAlert, ChevronRight } from "lucide-react";

export default function DepositAlert({ alerts }) {
  if (!alerts?.length) return null;
  return (
    <div className="mt-5 space-y-3" data-testid="deposit-alerts">
      {alerts.map((a) => (
        <div key={a.tenancy_id} data-testid={`deposit-alert-${a.property_id}`} className={`rounded-2xl border p-5 ${a.overdue ? "bg-rose-50 border-rose-200" : "bg-amber-50 border-amber-200"}`}>
          <div className="flex items-start gap-4">
            <div className={`shrink-0 grid place-items-center h-16 w-16 rounded-2xl text-white ${a.overdue ? "bg-rose-600" : "bg-amber-500"}`}>
              <div className="text-center leading-none"><div className="font-heading text-2xl font-extrabold">{Math.abs(a.days_left)}</div><div className="text-[10px] uppercase tracking-wide">{a.overdue ? "overdue" : "days"}</div></div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <ShieldAlert size={16} className={a.overdue ? "text-rose-600" : "text-amber-600"} />
                <p className={`font-semibold ${a.overdue ? "text-rose-900" : "text-amber-900"}`}>{a.overdue ? "Deposit protection deadline missed" : `Protect the deposit within ${a.days_left} day${a.days_left === 1 ? "" : "s"}`}</p>
              </div>
              <p className="text-xs text-muted-foreground mt-0.5">{a.property_name} · £{a.amount} received {a.received} · {a.nation}</p>
              <ol className="mt-3 space-y-1.5 text-sm list-decimal list-inside">
                {a.steps.map((s, i) => <li key={i} className={a.overdue && i === 2 ? "font-medium" : ""}>{s}</li>)}
              </ol>
              <div className="mt-3 flex flex-wrap gap-2" data-testid="deposit-scheme-links">
                {(a.nation === "Scotland" ? [["SafeDeposits Scotland", "https://www.safedepositsscotland.com/"], ["LPS Scotland", "https://www.lettingprotectionscotland.com/"], ["mydeposits Scotland", "https://www.mydepositsscotland.co.uk/"]] : [["DPS", "https://www.depositprotection.com/"], ["mydeposits", "https://www.mydeposits.co.uk/"], ["TDS", "https://www.tenancydepositscheme.com/"]]).map(([n, h]) => (
                  <a key={n} href={h} target="_blank" rel="noreferrer" className="text-xs px-3 min-h-[32px] inline-flex items-center rounded-lg bg-white border border-border hover:bg-secondary font-medium">Protect with {n} ↗</a>))}
              </div>
            </div>
            <Link to={`/properties/${a.property_id}`} data-testid={`deposit-fix-${a.property_id}`} className="shrink-0 self-center inline-flex items-center gap-1 text-sm font-semibold text-navy hover:underline">Fix it <ChevronRight size={16} /></Link>
          </div>
        </div>
      ))}
    </div>
  );
}
